import Backend from 'backend';
import {inject, bindable, customElement} from 'aurelia-framework';
import {Router} from "aurelia-router";

@customElement('customer-user-index-component')
@inject(Backend, Router)
export class CustomerUserIndexComponent {
  backend;
  router;
  customerUsers = [];

  @bindable() customerId;

  constructor(backend, router) {
    this.backend = backend;
    this.router = router;
  }

  attached() {
    return this.refresh();
  }

  refresh() {
    return this.backend.CustomerUserCrud_index(this.customerId)
      .then(result => {
        this.customerUsers = result
      });
  }
}
